import { combineReducers } from "@reduxjs/toolkit";
import { FixMeLater } from "types";
import { RootState } from "app/store";
import { sharedLib } from "@shared/services/shared.service";

const appReducer: any = combineReducers(sharedLib.getReducers());

const rootReducer: FixMeLater = (state: RootState, action: FixMeLater) => {
  if (
    sharedLib.sharedApi.authentication.endpoints.logout.matchFulfilled(action)
  ) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
